import styled from 'styled-components';

const Divider = styled.hr`
   border: 1px solid ${({ theme }) => theme.primaryGrey};
   border-radius: 1px;
   width: 100%;
   margin: 20px 0;
`;

export default Divider;
